// assets
import { LoginOutlined, ProfileOutlined, GroupOutlined, UserOutlined, UsergroupAddOutlined, UserSwitchOutlined } from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  ProfileOutlined,
  GroupOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const menuItems = {
  id: 'user-management',
  title: 'Người dùng',
  type: 'group',
  children: [
    {
      id: 'change-password',
      title: 'Đổi mật khẩu',
      type: 'item',
      url: '/change-password',
      icon: icons.UsergroupAddOutlined,
      target: false,
      visible: true
    },
    {
      id: 'profile',
      title: 'Trang cá nhân',
      type: 'item',
      url: '/profile',
      icon: icons.UserOutlined,
      target: false,
      visible: true
    },
    {
      id: 'direct-mock-results',
      title: 'Kết quả thi thử',
      type: 'item',
      url: '/direct-mock-results',
      icon: icons.ProfileOutlined,
      target: false,
      visible: true
    },
    {
      id: 'history',
      title: 'Lịch sử',
      type: 'item',
      url: '/history',
      icon: icons.UserOutlined,
      target: false,
      visible: true
    }
  ]
};

export default menuItems;
